export default {
  "Login for users": "Entrar na conta",
  Login: "Email / telefone",
  Password: "Senha",
  Submit: "Entrar",
  "Field required": "Campo obrigatório",
  "Auth error 400": "Login ou senha incorretos",
  "Auth error network":
    "Problema de conexão. Verifique sua internet e tente novamente.",
  "Auth error unknown": "Erro. Por favor, tente novamente mais tarde.",
  "Login title": "Autorização | " + process.env.VUE_APP_INSTALL_NAME + "",
  "Not account yet": "Ainda não tem conta?",
  "Not account yet about":
    "Você pode criar uma conta ou entrar no modo demo com funcionalidades limitadas",
  "Demo-mode": "Modo demo",
  "Let register": "Registrar",
  "User Agreement Title":
    "Contrato do usuário | " + process.env.VUE_APP_INSTALL_NAME + "",
  "User Agreement": "Contrato do usuário",
  "Privacy policy": "Política de tratamento de dados pessoais",
  "User Agreement About part 1":
    "Ao continuar a usar o site, você aceita os termos do ",
  "User Agreement About part 2": "contrato do usuário.",
  "User Agree": "Aceito",
  "Page not found": "Página não encontrada",
  "Page not found about":
    "O endereço está incorreto ou a página não existe mais. Volte para a página principal",
  "Back to main page": "Voltar para principal",
  "Login for users 2":
    "Obtenha acesso completo à plataforma " +
    process.env.VUE_APP_INSTALL_NAME +
    "",
  Step: "Passo",
  "Min 8": "Mínimo 8 caracteres",
  "1 char": "1 letra",
  "1 num": "1 número",
  "Auth access 1": "Concordo com ",
  "Auth access 2": "o tratamento de dados pessoais",
  "Auth access 3": ", aceito os termos da ",
  "Auth access 4": "política",
  "Auth access 5": "e",
  "Auth access 6": "do contrato do usuário",
  "Have account?": "Já tem conta?",
  "To next": "Próximo",
  "Reg for users 1": "Crie uma conta",
  "Reg for users 2": "Fale sobre você",
  "Reg for users 3": "Finalizar registro",
  "Your last_name": "Seu sobrenome",
  "Your first_name": "Seu nome",
  "Your middle_name": "Seu patronímico",
  "Your company": "Local de trabalho",
  "Your position_in_the_company": "Sua especialidade",
  Back: "Voltar",
  "Min 2": "Mínimo 2 caracteres",
  Promo: "Código promocional (se houver)",
  invitation_1: "De colegas / conhecidos",
  invitation_2: "Email marketing",
  invitation_3: "Pesquisa no Yandex, Google",
  invitation_4: "Outra fonte",
  invitation_5: "Redes sociais",
  "Where know about platform?": "Como soube da Plataforma?",
  "Reg finish": "Registrar-se",
  regErrorText: "Não foi possível registrar o usuário. Verifique os dados",
  "Auth banner text": "Autentique-se para obter acesso total à Plataforma",
  "Auth banner text 2":
    "Autentique-se para aumentar o número de estudos para processamento",
  "Auth banner text 3":
    "Receba o processamento gratuito de 10<br/>dos seus estudos",
  "Reg error":
    "Infelizmente, o registro falhou devido a um erro técnico. Tente novamente mais tarde",
  "Reg error 400": "Este endereço de e-mail já está sendo utilizado",
  "Rem password": "Digite o e-mail utilizado no cadastro",
  Phone: "Telefone",
  "Not valid phone": "Formato de número de telefone inválido",
  emailVerify: {
    title: "Confirmação de email",
    desc1: "Um e-mail foi enviado para ",
    desc2:
      " com um link de confirmação. Por favor, clique no link para ativar sua conta e obter acesso ao serviço.",
  },
};
